import { useCallback, useRef } from "react";
import {
  signInWithEmailAndPassword,
  sendEmailVerification,
  signOut,
} from "firebase/auth";
import { auth } from "../utilities/firebase";

export const useResendVerification = () => {
  const credentialsRef = useRef<{ email: string; password: string } | null>(
    null
  );

  const setCredentials = useCallback((email: string, password: string) => {
    credentialsRef.current = { email, password };
  }, []);

  const handleResend = useCallback(async () => {
    if (!credentialsRef.current) return;
    const { email, password } = credentialsRef.current;
    const result = await signInWithEmailAndPassword(auth, email, password);
    try {
      await sendEmailVerification(result.user);
    } finally {
      await signOut(auth);
    }
  }, []);

  return {
    setCredentials,
    handleResend,
  };
};

export default useResendVerification;
